import React from "react";
import PropTypes from "prop-types";
import CloseSolid from "@learningblocks/exp-constants/lib/Icons/close-solid";
import CorrectSolid from "@learningblocks/exp-constants/lib/Icons/correct-solid";
import { Tooltip } from "@learningblocks/shared-components/";

export function FeedbackIcon({ className, showFeedback, isSuccess, feedback }) {
  let feedbackIcon = null;
  if (showFeedback && !isSuccess) {
    feedbackIcon = (
      <Tooltip
        title={feedback}
        direction="right"
        className={className}
        type="PLAIN"
      >
        <CloseSolid style={{ width: "22px", height: "22px" }} />
      </Tooltip>
    );
  } else if (showFeedback && isSuccess) {
    feedbackIcon = (
      <span className="tooltip-wrap dataTable_row_cell_feedback">
        <CorrectSolid style={{ width: "22px", height: "22px" }} />
      </span>
    );
  }
  return feedbackIcon;
}

FeedbackIcon.propTypes = {
  /**
   * className to set of the icon
   */
  className: PropTypes.string,
  /**
   * Boolean to set if feeback should be displayed
   */
  showFeedback: PropTypes.bool,
  /**
   * Boolean to set if feedback success/failure
   */
  isSuccess: PropTypes.bool,
};
